// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast_d4U9r {
  font: normal 13px/20px Inter;
  color: var( --color-base700 );
  border: 1px solid var( --color-base100 );
  box-shadow: 0 4px 8px var( --color-shadowBase );
  padding-left: var( --size-padLarge );
  border-radius: 4px;
  padding-right: var( --size-padMedium );
}
.toast_d4U9r .Toastify__progress-bar {
  background-color: var( --color-base200 );
}
.toast_d4U9r.toast-success_SLv1U {
  background: var( --color-white );
}
.toast_d4U9r.toast-success_SLv1U .Toastify__progress-bar {
  background-color: var( --color-success500 );
}
.toast_d4U9r.toast-error_pWcnE {
  background: var( --color-white );
}
.toast_d4U9r.toast-error_pWcnE .Toastify__progress-bar {
  background-color: var( --color-danger500 );
}
.toast_d4U9r.toast-warn_uWcaX {
  background: var( --color-white );
}
.toast_d4U9r.toast-warn_uWcaX .Toastify__progress-bar {
  background-color: var( --color-warning500 );
}
.toast_d4U9r.toast-info_rpx0E .Toastify__progress-bar {
  background-color: var( --color-brand500 );
}`, "",{"version":3,"sources":["webpack://./src/theme/Toast.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,wCAAwC;EACxC,+CAA+C;EAC/C,oCAAoC;EACpC,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,gCAAgC;AAClC;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,gCAAgC;AAClC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,gCAAgC;AAClC;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,yCAAyC;AAC3C","sourcesContent":[".toast {\n  font: normal 13px/20px Inter;\n  color: var( --color-base700 );\n  border: 1px solid var( --color-base100 );\n  box-shadow: 0 4px 8px var( --color-shadowBase );\n  padding-left: var( --size-padLarge );\n  border-radius: 4px;\n  padding-right: var( --size-padMedium );\n}\n.toast :global( .Toastify__progress-bar ) {\n  background-color: var( --color-base200 );\n}\n.toast.toast-success {\n  background: var( --color-white );\n}\n.toast.toast-success :global( .Toastify__progress-bar ) {\n  background-color: var( --color-success500 );\n}\n.toast.toast-error {\n  background: var( --color-white );\n}\n.toast.toast-error :global( .Toastify__progress-bar ) {\n  background-color: var( --color-danger500 );\n}\n.toast.toast-warn {\n  background: var( --color-white );\n}\n.toast.toast-warn :global( .Toastify__progress-bar ) {\n  background-color: var( --color-warning500 );\n}\n.toast.toast-info :global( .Toastify__progress-bar ) {\n  background-color: var( --color-brand500 );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toast": `toast_d4U9r`,
	"toast-success": `toast-success_SLv1U`,
	"toast-error": `toast-error_pWcnE`,
	"toast-warn": `toast-warn_uWcaX`,
	"toast-info": `toast-info_rpx0E`
};
export default ___CSS_LOADER_EXPORT___;
